import appConfig from 'app-config';
import {JsonRPCService} from "gw-portals-transport-js";
import {getProxiedServiceUrl} from "gw-portals-url-js";
/*
Go through the below URL to look for documentation
https://docs.precisely.com/docs/sftw/spectrum/18.2/en/webhelp/OnDemand-REST/index.html#OnDemand/source/LandingPageForHelp.html
 */
export default class PitneyBowesService {
    static createAddressingInstanceKey() {
        //let instanceKeyRequestURL = `https://amer-staging.spectrum.precisely.com/rest/CreateAddressingInstanceKey/results.json`;
        let instanceKeyRequestURL = process.env.REACT_APP_PB_INSTANCE_KEY_URL;
        return fetch(instanceKeyRequestURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Basic ${appConfig.credentials.pitneyBowesApiKey}`
            }
        }).then(res => res.json())
            .then(json => {
                return json.Output[0].InstanceKey;
            });
    }

    static globalTypeAheadCANRequest (instanceKey, addressFragment) {
        //let globalTypeAheadCAN = `https://amer-staging.spectrum.precisely.com/rest/GlobalTypeAheadUSCAN/results.json`;
        let globalTypeAheadCAN = process.env.REACT_APP_PB_GLOBAL_AHEAD_URL;
        if (addressFragment != '' && addressFragment != undefined) {
            globalTypeAheadCAN = globalTypeAheadCAN + '?' + 'Data.InstanceKey=' + instanceKey;
            globalTypeAheadCAN = globalTypeAheadCAN + '&' + 'Data.AddressLine1=' + addressFragment;
            globalTypeAheadCAN = globalTypeAheadCAN + '&' + 'Data.StateProvince=' + 'ON';
            globalTypeAheadCAN = globalTypeAheadCAN + '&' + 'Data.Country=' + 'CAN';
        }
        return fetch(globalTypeAheadCAN, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Basic ${appConfig.credentials.pitneyBowesApiKey}`
            }
        });
    }
}
